import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';

import { ChurnFlowTestimonial } from '@core/churn-flow-types';

@Component({
  selector: 'tlc-churn-flow-testimonial',
  templateUrl: './churn-flow-testimonial.component.html',
  styleUrls: ['./churn-flow-testimonial.component.less'],
  standalone: true,
  imports: [NgOptimizedImage],
})
export class ChurnFlowTestimonialComponent {
  public testimonial = input.required<ChurnFlowTestimonial>();
}
